import { AxiosInstance, AxiosResponse } from 'axios';
import { ParsedUrlQuery } from 'querystring';
import { IFunderAwardsSummaryStats } from '@models/IFunderAwardSummary';
import { CriteriaData } from '@models/CriteriaData';
import AxiosClientBuilder, { ApiName } from '../../AxiosClientBuilder';

export class SearchApi {
  private static ROOT = '/search';

  private static searchClient: AxiosInstance = new AxiosClientBuilder()
    .setApiName(ApiName.Awards)
    .setPrivate(true)
    .build();

  static fetchFunderAwards(
    criteria: CriteriaData[],
    offset: number,
    { totalPublications, year, impact, risk }: ParsedUrlQuery,
  ): Promise<AxiosResponse<IFunderAwardsSummaryStats>> {
    return this.searchClient.get<IFunderAwardsSummaryStats>(`${this.ROOT}/`, {
      params: {
        criteria: JSON.stringify(criteria),
        offset,
        publicationCount: totalPublications,
        year,
        impact,
        risk,
      },
    });
  }
}
